export default __webpack_public_path__ + "static/media/noba_album_art.762e31cb.jpg";